import { render, staticRenderFns } from "./MoreIcon.vue?vue&type=template&id=0252b40b"
import script from "./MoreIcon.vue?vue&type=script&lang=js"
export * from "./MoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports